module.exports = __webpack_public_path__ + "static/img/AvenirLTProBlack.58b0357.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/quiz-fonts/AvenirLTProBlack.svg
// module id = Gqze
// module chunks = 1